import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { UPDATE_CHALLENGE_RELATIONS_DETAILS_MUTATION } from '../graphql/mutations'
import { transformToUpdateChallengeRelationsDetailsArgs } from '../graphql/transformers'
import { UPDATE_CHALLENGE_RELATIONS_DETAILS } from '../redux/action-types'

const useUpdateChallengeRelationsDetailsMutation = () => {
  const dispatch = useDispatch()

  const { isRelationsDetailsLoading, relationsDetailsError } = useSelector(
    store => store.challenges.challenge,
  )

  const mutate = useCallback(
    (id, data) =>
      apolloService.mutate(
        UPDATE_CHALLENGE_RELATIONS_DETAILS_MUTATION,
        {
          id,
          data: transformToUpdateChallengeRelationsDetailsArgs(data),
        },
        dispatch,
        UPDATE_CHALLENGE_RELATIONS_DETAILS,
      ),
    [dispatch],
  )

  return [
    mutate,
    {
      isLoading: isRelationsDetailsLoading,
      error: relationsDetailsError,
    },
  ]
}

export default useUpdateChallengeRelationsDetailsMutation
